import { Injectable } from "@angular/core";
import { NgxMsgPosition } from "../interfaces/ngx-msg.constants";
export var NgxMsgConfigService = (function () {
    function NgxMsgConfigService() {
        this.position = NgxMsgPosition.TopRight;
        this.visibleTime = 5000;
        this.closeOnClick = true;
    }
    NgxMsgConfigService.decorators = [
        { type: Injectable },
    ];
    NgxMsgConfigService.ctorParameters = [];
    return NgxMsgConfigService;
}());
//# sourceMappingURL=ngx-msg-config.service.js.map